export const RECEIVE_PAGES = 'RECEIVE_PAGES'

export const RECEIVE_SITE = 'RECEIVE_SITE'

export const RECEIVE_VOTES = 'RECEIVE_VOTES'

export const RECEIVE_RESET = 'RECEIVE_RESET'

export const UPDATE_APP = 'UPDATE_APP'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js